<app-header class="app-header"></app-header>
<div class="app-content">
  <router-outlet></router-outlet>
</div>
